import Vue from 'vue';
import { apiPath } from '../constants';

const Notifications = Vue.resource(
  `${apiPath}/notifications{/id}/`,
  {},
  {
    seen: { method: 'PUT' },
  },
);

export default Notifications;
